import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
  productData: [],
  favorites: [],
  returnRefund: [],
  compare: [],
  userInfo: {
    addresses: [],
    payments: [],
    defaultAdd: 0,
    defaultPay: 0,
  },
  selectedBook: [],
  selectedCollaborator: [],
  collection: [],
  selectedLanguage: [{ Language: "fr" }],
  selectedCurrency: [{ currency: "eur" }],
  searchData: [],
  orderData: [],
  selectedOption: "logo",
  selectedRows: [],
  adminUser: {},
  userData: {},
  eventData: {},
  heroData: {},
  reviewData: {},
  paymentData: {},
  articleData: {},
  contactData: {},
  selectedCategoryId: null,
  orderInvoiceData: {},
  orderItemData: {},
  retutnInvoiceData: {},
  returnItemData: {},
  menuOption: {},
};

export const productSlice = createSlice({
  name: `${process.env.REACT_APP_ECOM_TYPE}`,
  initialState,
  reducers: {
    addInitialcart: (state, action) => {
      state.productData.push(action.payload);
    },
    addTocart: (state, action) => {
      // if (!state.userInfo) {
      //     toast.error(`Please log in to add items.`, {
      //         position: "top-right",
      //         autoClose: 1500,
      //         hideProgressBar: true,
      //         closeOnClick: true,
      //         pauseOnHover: true,
      //         draggable: true,
      //         progress: 0,
      //         theme: "colored",
      //     });
      //     return;
      // }

      const item = state.productData.find(
        (item) => item._id === action.payload._id
      );
      if (item) {
        // If item already exists in cart, update its quantity
        item.quantity =
          Number(item.quantity) + Number(action.payload.quantity) ||
          Number(item.quantity) + 1; // Increment by 1 if no quantity specified
      } else {
        // If item doesn't exist in cart, add it
        state.productData.push(action.payload);
      }
    },
    editCart: (state, action) => {
      const item = state.productData.find(
        (item) => item._id === action.payload._id
      );
      if (item) {
        item.discount = Number(action.payload.discount) || item.discount;
      }
    },
    deleteItem: (state, action) => {
      if (action.payload.article_variant_combination) {
        console.log("Deleting item in slice:", action.payload);
        const variantId = action.payload.article_variant_combination.id;
        const itemId = action.payload._id;
        state.productData = state.productData.filter(
          (item) =>
            !(item.article_variant_combination?.id === variantId &&
              item._id === itemId)
        );
      } else {
        const itemId = action.payload._id;
        state.productData = state.productData.filter(
          (item) => item._id !== itemId
        );
      }
      // console.log(state.productData);
    },
    resetCart: (state) => {
      state.productData = [];
    },
    increamentQuantity: (state, action) => {
      const item = state.productData.find(
        (item) => item._id === action.payload._id
      );
      if (item) {
        item.quantity++;
      }
    },
    decreamentQuantity: (state, action) => {
      const item = state.productData.find(
        (item) => item._id === action.payload._id
      );
      if (item) {
        item.quantity--;
      }
    },
    updateItemNote: (state, action) => {
      const item = state.productData.find(
        (item) => item._id === action.payload._id
      );
      if (item) {
        item.note = action.payload.note;
      }
    },

    addUserData: (state, action) => {
      state.userData = {
        ...action.payload,
      };
    },
    addHeroData: (state, action) => {
      state.heroData = {
        ...action.payload,
      };
    },
    addEventData: (state, action) => {
      state.eventData = {
        ...action.payload,
      };
    },
    addPaymentData: (state, action) => {
      state.paymentData = {
        ...action.payload,
      };
    },
    addReviewData: (state, action) => {
      state.reviewData = {
        ...action.payload,
      };
    },
    addArticleData: (state, action) => {
      state.articleData = {
        ...action.payload,
      };
    },
    addOrderInvoiceData: (state, action) => {
      state.orderInvoiceData = {
        ...action.payload,
      };
    },
    addOrderItemData: (state, action) => {
      state.orderItemData = {
        ...action.payload,
      };
    },
    setMenuOption: (state, action) => {
      state.menuOption = {
        ...action.payload,
      };
    },
    addReturnItemData: (state, action) => {
      state.returnItemData = {
        ...action.payload,
      };
    },
    addRetutnInvoiceData: (state, action) => {
      state.retutnInvoiceData = {
        ...action.payload,
      };
    },
    addContactData: (state, action) => {
      state.contactData = {
        ...action.payload,
      };
    },
    addAdminUser: (state, action) => {
      state.adminUser = {
        ...action.payload,
      };
    },

    resetAdminUser: (state) => {
      state.adminUser = {}; // Reset adminUser to an empty object
    },

    addUser: (state, action) => {
      state.userInfo = {
        ...action.payload,
        addresses: action.payload.addresses
          ? [...action.payload.addresses]
          : [], // Copy the addresses array if it exists, otherwise use an empty array
        payments: action.payload.payments ? [...action.payload.payments] : [],
      };
    },
    editUser: (state, action) => {
      const { image, ...updatedFields } = action.payload;

      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          ...updatedFields,
          image: image || state.userInfo.image,
        },
      };
    },
    addAddress: (state, action) => {
      const newAddress = action.payload;

      // Check if userInfo and addresses array exist
      if (state.userInfo && state.userInfo.addresses) {
        // Add the new address to the addresses array
        state.userInfo.addresses.push(newAddress);
      }
    },
    editAddress: (state, action) => {
      const { addressId, formData } = action.payload;

      // Check if userInfo and addresses array exist
      if (state.userInfo && state.userInfo.addresses) {
        // Find the index of the address to be edited
        const addressIndex = state.userInfo.addresses.findIndex(
          (address) => address.id === addressId
        );

        // If the address is found, update it
        if (addressIndex !== -1) {
          state.userInfo.addresses[addressIndex] = {
            ...state.userInfo.addresses[addressIndex],
            ...formData,
          };
        }
      }
    },
    editDefaultAdd: (state, action) => {
      // Extract the new defaultAdd value from the action payload
      const newDefaultAdd = action.payload;

      // Check if userInfo exists
      if (state.userInfo) {
        // Update the defaultAdd value
        state.userInfo.defaultAdd = newDefaultAdd;
      }
    },
    deleteAddress: (state, action) => {
      state.userInfo.addresses = state.userInfo.addresses.filter(
        (item) => item.id !== action.payload
      );
    },
    resetAddresses: (state, action) => {
      state.userInfo.addresses = null;
    },

    addSelectedBook: (state, action) => {
      state.selectedBook = [];
      const book = action.payload;

      state.selectedBook.push(book);
    },
    addOrderData: (state, action) => {
      state.orderData = [];
      const data = action.payload;

      state.orderData.push(data);
    },
    resetOrderData: (state) => {
      state.orderData = [];
    },
    changeLanguage: (state, action) => {
      state.selectedLanguage = [];
      const language = action.payload;

      state.selectedLanguage.push(language);
    },
    changeCurrency: (state, action) => {
      state.selectedCurrency = [];
      const currency = action.payload;

      state.selectedCurrency.push(currency);
    },

    deleteSelectedBook: (state) => {
      state.selectedBook = [];
    },

    addPayment: (state, action) => {
      const newPayment = action.payload;

      if (state.userInfo && state.userInfo.payments) {
        state.userInfo.payments.push(newPayment);
      }
    },
    editPayment: (state, action) => {
      const { paymentId, values } = action.payload;

      if (state.userInfo && state.userInfo.payments) {
        const paymentIndex = state.userInfo.payments.findIndex(
          (payment) => payment.id === paymentId
        );

        if (paymentIndex !== -1) {
          state.userInfo.payments[paymentIndex] = {
            ...state.userInfo.payments[paymentIndex],
            ...values,
          };
        }
      }
    },
    editDefaultPAY: (state, action) => {
      // Extract the new defaultAdd value from the action payload
      const newDefaultpay = action.payload;

      // Check if userInfo exists
      if (state.userInfo) {
        // Update the defaultAdd value
        state.userInfo.defaultPay = newDefaultpay;
      }
    },
    deletePayment: (state, action) => {
      state.userInfo.payments = state.userInfo.payments.filter(
        (item) => item.id !== action.payload
      );
    },
    removeUser: (state, action) => {
      state.userInfo = null;
      state.compare = [];
      state.favorites = [];
      state.productData = [];
    },
    addTofavorite: (state, action) => {
      if (!state.userInfo) {
        toast.error(
          `${
            state.products.selectedLanguage[0].language === "eng"
              ? "Please login to add to wishlist."
              : "Veuillez vous connecter pour ajouter à votre liste de souhaits."
          }`,
          {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
            theme: "colored",
          }
        );
        return;
      } else {
        state.favorites.push(action.payload);
      }
    },
    changeFavorite: (state, action) => {
      const item = state.favorites.find(
        (item) => item._favid === action.payload._favid
      );
      if (item) {
        item.favquantity = action.payload.favquantity;
      }
    },
    increamentfavQuantity: (state, action) => {
      const item = state.favorites.find(
        (item) => item._favid === action.payload._favid
      );
      if (item) {
        item.favquantity++;
      }
    },
    decreamentfavQuantity: (state, action) => {
      const item = state.favorites.find(
        (item) => item._favid === action.payload._favid
      );
      if (item) {
        item.favquantity--;
      }
    },
    deletefavorite: (state, action) => {
      state.favorites = state.favorites.filter(
        (item) => item.id !== action.payload
      );
    },
    resetfavorite: (state) => {
      state.favorites = [];
    },
    addTocompare: (state, action) => {
      if (!state.userInfo) {
        toast.error(
          `${
            state.products.selectedLanguage[0].language === "eng"
              ? "Please login to add items."
              : "Veuillez vous connecter pour ajouter des articles."
          }`,
          {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
            theme: "colored",
          }
        );
        return;
      } else {
        if (state.compare?.length < 3) {
          state.compare.push(action.payload);
          //   console.log(action.payload.comtitle)
          toast.success(
            `${
              action.payload.comtitle ? action.payload.comtitle : "Book"
            } is added`,
            {
              position: "top-right",
              autoClose: 1500,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
              theme: "colored",
            }
          );
        } else {
          toast.error("Can't add more than 3", {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
            theme: "colored",
          });
        }
      }
    },
    deletecompare: (state, action) => {
      state.compare = state.compare.filter(
        (item) => item._comid !== action.payload
      );
    },
    resetcompare: (state) => {
      state.compare = [];
    },
    addToreturnRefund: (state, action) => {
      if (state.returnRefund?.length < 3) {
        state.returnRefund.push(action.payload);
      } else {
        // Handle the case where the array length is already 3
        // For example, you might want to show a message or take some other action
        //   console.error("Cannot add more than 3 items to returnRefund.");
      }
    },
    editReturnRefund: (state, action) => {
      const { id, updatedData } = action.payload;
      const existingItemIndex = state.returnRefund.findIndex(
        (item) => item.id === id
      );

      if (existingItemIndex !== -1) {
        // If item exists, update the data
        state.returnRefund[existingItemIndex] = {
          ...state.returnRefund[existingItemIndex],
          ...updatedData,
        };
        toast.success(`Item updated with new data`, {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
          theme: "colored",
        });
      } else {
        //   console.error("Item not found for editing.");
        toast.error("Item not found for editing.");
      }
    },
    deletereturnRefund: (state, action) => {
      state.returnRefund = state.returnRefund.filter(
        (item) => item.id !== action.payload
      );
    },
    // addSearchData: (state, action) => {
    //     if (state.searchData.length > 0) {
    //         // Update the first object while keeping existing properties
    //         state.searchData[0] = {
    //             ...state.searchData[0],
    //             ...action.payload,
    //         };
    //     } else {
    //         // If the array is empty, add a new object
    //         state.searchData.push(action.payload);
    //     }
    // },

    addSearchData: (state, action) => {
      if (state.searchData?.length > 0) {
        const key = Object.keys(action.payload)[0]; // Get the first key dynamically
        const value = action.payload[key];

        let existingValues = [];

        // Handle different data types
        if (typeof state.searchData[0][key] === "string") {
          existingValues = state.searchData[0][key].split("; ");
        } else if (typeof state.searchData[0][key] === "number") {
          if (key === "collaborators") {
            existingValues = [state.searchData[0][key].toString()];
          } else {
            existingValues = state.searchData[0][key].split("; ");
          }
        } else if (Array.isArray(state.searchData[0][key])) {
          existingValues = [...state.searchData[0][key]];
        }

        if (existingValues.includes(value)) {
          // Remove the value if it exists
          existingValues = existingValues.filter((item) => item !== value);
        } else {
          // Add the value if it doesn't exist
          existingValues.push(value);
        }

        // Update state: Store as array instead of string
        if (existingValues.length > 0) {
          state.searchData[0] = {
            ...state.searchData[0],
            [key]: existingValues,
          };
        } else {
          delete state.searchData[0][key];
        }
      } else {
        // If the array is empty, add a new object with array value
        const key = Object.keys(action.payload)[0];
        const value = action.payload[key];
        state.searchData.push({ [key]: [value] });
      }
    },

    // Edit function for editing an existing search data item
    editSearchData: (state, action) => {
      state.searchData = [action.payload];
    },

    resetSearchData: (state) => {
      state.searchData = [];
    },

    addSelectedCollab: (state, action) => {
      const collab = action.payload;

      state.selectedCollaborator.push(collab);
    },

    deleteSelectedCollab: (state) => {
      state.selectedCollaborator = [];
    },

    addCollection: (state, action) => {
      state.collection = [];
      state.collection.push(action.payload);
    },
    addSelectedRows: (state, action) => {
      const { key, value } = action.payload;
      const existingIndex = state.selectedRows.findIndex(
        (row) => row.key === key
      );

      if (existingIndex !== -1) {
        // Key exists, update its value
        state.selectedRows[existingIndex].value = value;
      } else {
        // Key doesn't exist, add new entry
        state.selectedRows.push({ key, value });
      }
    },
    setSelectedOption: (state, action) => {
      state.selectedOption = action.payload;
    },

    addSelectedCategory: (state, action) => {
      state.selectedCategoryId = null;
      const category = action.payload;

      state.selectedCategoryId = category;
    },
  },
});

export const {
  addSearchData,
  resetOrderData,
  addSelectedCategory,
  addSelectedRows,
  addPaymentData,
  addRetutnInvoiceData,
  addOrderInvoiceData,
  addOrderItemData,
  addReturnItemData,
  setMenuOption,
  addReviewData,
  setSelectedOption,
  addOrderData,
  addCollection,
  addSelectedCollab,
  deleteSelectedCollab,
  editSearchData,
  resetSearchData,
  addInitialcart,
  addTocart,
  editCart,
  deleteItem,
  resetCart,
  changeLanguage,
  changeCurrency,
  addSelectedBook,
  deleteSelectedBook,
  increamentQuantity,
  addAddress,
  addPayment,
  updateItemNote,
  decreamentQuantity,
  addContactData,
  addArticleData,
  addUserData,
  addHeroData,
  addEventData,
  addAdminUser,
  resetAdminUser,
  addUser,
  deleteAddress,
  resetAddresses,
  editUser,
  editAddress,
  editPayment,
  deletePayment,
  removeUser,
  addTofavorite,
  changeFavorite,
  increamentfavQuantity,
  decreamentfavQuantity,
  deletefavorite,
  resetfavorite,
  addTocompare,
  deletecompare,
  resetcompare,
  addToreturnRefund,
  editReturnRefund,
  deletereturnRefund,
  editDefaultAdd,
  editDefaultPAY,
} = productSlice.actions;
export default productSlice.reducer;
